import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router";
import { useAuth } from "@/hooks/useAuth";

export const Auth: React.FC = () => {
	const { generateToken, login } = useAuth();
	const [searchParams] = useSearchParams();
	const [error, setError] = useState<string | null>(null);
	const effectCalled = useRef(false);

	useEffect(() => {
		if (effectCalled.current) return;
		const code = searchParams.get("code");
		if (code) {
			generateToken(code).catch(() => {
				setError("Failed to generate token");
			});
			effectCalled.current = true;
		} else {
			setError("Authorization code not found");
		}
	}, [searchParams, generateToken]);

	useEffect(() => {
		if (error) {
			login();
		}
	}, [error, login]);

	return null;
};
